import InfiniteScroll from "react-infinite-scroller";

import {
  ActionBar,
  ActionBarButtons,
  CreateActionButton,
  Container,
  List,
  Loader,
  useApi,
  useUser,
  tenantShape,
} from "lcm-iot-commons";
import { useIntl } from "react-intl";

import TenantItem from "./TenantItem";
import NoTenants from "./NoTenants";

export default function Tenants() {
  const api = useApi();
  const intl = useIntl();
  const user = useUser();

  const {
    data,
    isInitialLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = api.get.useInfiniteQuery(
    "/tenants",
    {
      order_by: "name",
      admin_or_user_id: user?.id,
    },
    {
      enabled: !!user?.id,
      // @ts-expect-error TS(2322) FIXME: Type '(response: InfiniteData<PaginatedResponse>) ... Remove this comment to see the full error message
      select: (response) => ({
        tenants: response.pages.flatMap((page) => (page as $TSFixMe).tenants),
        totalCount:
          (response.pages[0]?.pagination as $TSFixMe)?.total_count || 0,
      }),
    },
  );

  const isLoading = isInitialLoading || isFetchingNextPage;
  const tenants = (data as $TSFixMe)?.tenants || [];
  const totalCount = (data as $TSFixMe)?.totalCount;
  const tenantsCount = totalCount > 0 ? totalCount : null;

  const badge = isLoading ? (
    <span className="loading">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  ) : (
    tenantsCount
  );

  const tenantsList = (
    <List id="tenants-list">
      <InfiniteScroll
        initialLoad={false}
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        loadMore={fetchNextPage}
        hasMore={hasNextPage && !isFetchingNextPage}
      >
        {tenants.map((tenant: tenantShape) => (
          <TenantItem key={tenant.id} tenant={tenant} removeTenant={refetch} />
        ))}
      </InfiniteScroll>
    </List>
  );

  const noTenants = !isLoading && tenants.length === 0 ? <NoTenants /> : null;

  return user ? (
    <Container>
      <ActionBar>
        <h1 id="tenants-header">
          {intl.formatMessage({ id: "tenants.header" })}
          <span
            id="tenants-count"
            data-testid="tenants-count"
            className="badge"
          >
            {badge}
          </span>
        </h1>
        <ActionBarButtons>
          <CreateActionButton
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; }' is not assi... Remove this comment to see the full error message
            id="create-tenant-button"
            target="/tenants/create"
          />
        </ActionBarButtons>
      </ActionBar>
      {tenants.length > 0 && tenantsList}
      {noTenants}
      <Loader loading={isLoading} />
    </Container>
  ) : null;
}
